




































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { maskCPFCNPJ, maskDateTime, maskMoney, timeoutDefault } from '@/utils/common'
import { RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'
import FileSaver from 'file-saver'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'

@Component
export default class ComponentModalValidacaoEGeracaoRepasse extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadShowModalItensDoRepasse: string = ''
  loadShowModalDesfazerLiberacao: string = ''
  loadShowModalIntegrarRepasseUnico: string = ''
  loadShowModalLiberarRepasseUnico: string = ''
  loadShowModalDescontosPrestador: string = ''
  loadShowModalDesfazerIntegracao: string = ''
  loadShowModalEmitirRelatorio: boolean = false
  loadDownloadArquivos: string = ''
  loadShowModalItemAvulso: string = ''
  loadHistorico: string = ''
  loadShowModalErros: boolean = false
  modalLiberarRepasses: boolean = false
  selection: any[] = []
  activeTab: number = 0

  get modalValidacaoEGeracaoRepasse() { return this.getFinanceiroStore.modal.validacaoEGeracaoRepasse }
  set modalValidacaoEGeracaoRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'validacaoEGeracaoRepasse', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get temMensagemDeErro() {
    return this.getFinanceiroStore.podeLiberar === 'Erro'
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get loadingShowModalItensDoRepasse() {
    return this.loadShowModalItensDoRepasse
  }

  set loadingShowModalItensDoRepasse(value: string) {
    this.loadShowModalItensDoRepasse = value
  }

  get loadingShowModalDesfazerLiberacao() {
    return this.loadShowModalDesfazerLiberacao
  }

  set loadingShowModalDesfazerLiberacao(value: string) {
    this.loadShowModalDesfazerLiberacao = value
  }

  get loadingShowModalIntegrarRepasseUnico() {
    return this.loadShowModalIntegrarRepasseUnico
  }

  set loadingShowModalIntegrarRepasseUnico(value: string) {
    this.loadShowModalIntegrarRepasseUnico = value
  }

  get loadingShowModalLiberarRepasseUnico() {
    return this.loadShowModalLiberarRepasseUnico
  }

  set loadingShowModalLiberarRepasseUnico(value: string) {
    this.loadShowModalLiberarRepasseUnico = value
  }

  get loadingShowModalDescontosPrestador() {
    return this.loadShowModalDescontosPrestador
  }

  set loadingShowModalDescontosPrestador(value: string) {
    this.loadShowModalDescontosPrestador = value
  }

  get loadingShowModalDesfazerIntegracao() {
    return this.loadShowModalDesfazerIntegracao
  }

  set loadingShowModalDesfazerIntegracao(value: string) {
    this.loadShowModalDesfazerIntegracao = value
  }

  get loadingShowModalEmitirRelatorio() {
    return this.loadShowModalEmitirRelatorio
  }

  set loadingShowModalEmitirRelatorio(value: boolean) {
    this.loadShowModalEmitirRelatorio = value
  }

  get loadingDownloadArquivos() {
    return this.loadDownloadArquivos
  }

  set loadingDownloadArquivos(value: string) {
    this.loadDownloadArquivos = value
  }

  get loadingShowModalItemAvulso() {
    return this.loadShowModalItemAvulso
  }

  set loadingShowModalItemAvulso(value: string) {
    this.loadShowModalItemAvulso = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingShowModalErros() {
    return this.loadShowModalErros
  }

  set loadingShowModalErros(value: boolean) {
    this.loadShowModalErros = value
  }

  get headersVisualizarGeracaoRepasse() {
    return this.getFinanceiroStore.backofficeFinanceiroGeracaoRepasseVisualizarHeaders
  }

  get headersVisualizarCargas() {
    return [
      { text: 'Criado por', value: 'createdByNome', align: 'center' },
      { text: 'Transação financeira', value: 'transacaoFinanceira', align: 'center' },
      { text: 'Centro de custo', value: 'centroCusto', align: 'center' },
      { text: 'Motivo inclusão', value: 'motivoInclusao', align: 'center' },
      { text: 'Observação', value: 'observacao', align: 'center' },
      { text: 'Criado em', value: 'createdOn', align: 'center' },
      { text: 'Ação', value: 'acao', align: 'center' },
    ]
  }

  get geracaoDeRepassesItemsVisualizar() {
    return this.getFinanceiroStore.geracaoDeRepassesItemsVisualizar
  }

  get cargasVisualizarItems() {
    return this.getFinanceiroStore.cargasVisualizarItems
  }

  get acoesGeracaoRepasse() {
    return this.getFinanceiroStore.acoesGeracaoRepasse
  }

  get dadosGeraisDoRepasse() {
    return this.getFinanceiroStore.dadosGeraisDoRepasse
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getTotal() {
    return this.getFinanceiroStore.totalGeracaoDeRepasseVisualizar || 0
  }

  get desfazerIntegracao() {
    return this.getFinanceiroStore.modal.desfazerIntegracao
  }

  get repasseLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get modalDescartarRepasse() {
    return this.getFinanceiroStore.modal.descartarRepasses
  }

  calcularValorLiquido(item: any) {
    const { valorTotal, descontos } = item
    let valorLiquido = valorTotal

    // Percorrer a lista de descontos e subtrair o valor de cada desconto
    descontos.forEach((desconto: any) => {
      valorLiquido -= desconto.valorTotal || 0
    })

    return (item.valorLiquido === valorLiquido) ? this.maskMoneyUtil(item.valorLiquido) : this.maskMoneyUtil(valorLiquido)
  }

  maskCpfCnpjUtil(value) {
    return maskCPFCNPJ(value)
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  formatDateTime(date) {
    return maskDateTime(date)
  }

  formatMonthUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('MM/YYYY')
  }

  formatDateUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY')
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  showModalAlterarAluguelPrestador(id: string) {
    this.getFinanceiroStore.setIdForSaveAlterarPrestador(id)
    this.getFinanceiroStore.setModal({ name: 'modalAlterarAluguelPrestador', value: true })
  }

  openModalLiberarRepasses() {
    this.getFinanceiroStore.setModal({ name: 'liberarRepasses', value: true })
  }

  openModalIntegrarRepasses() {
    this.getFinanceiroStore.setModal({ name: 'integrarRepasses', value: true })
  }

  openModalDescartarRepasses() {
    this.getFinanceiroStore.setModal({ name: 'descartarRepasses', value: true })
  }

  async openModalErrosValidacao() {
    this.loadingShowModalErros = true
    await this.getFinanceiroStore.getValidacaoErros()
    this.getFinanceiroStore.setModal({ name: 'errosValidacao', value: true })
    this.loadingShowModalErros = false
  }

  async showModalItemAvulso(id: string) {
    this.loadingShowModalItemAvulso = id
    this.getFinanceiroStore.setIdForLoadItemAvulso(id)

    // Verifica se existem itens salvos da última requisição
    const { codigoProcedimento, centroDeCusto, transacaoFinanceira, profissionaisExecutantes, motivosInclusaoItemAvulso, funcoesProfissionalExecutante, conveniosRepasse, viasAcesso } = this.getFinanceiroStore

    if (!codigoProcedimento.length) await this.getFinanceiroStore.getProcedimentos()
    if (!transacaoFinanceira.length) await this.getFinanceiroStore.getTransacaoFinanceira()
    if (!centroDeCusto.length) await this.getFinanceiroStore.getCentroDeCusto()
    if (!profissionaisExecutantes.length) await this.getFinanceiroStore.getProfissionais()
    if (!funcoesProfissionalExecutante.length) await this.getFinanceiroStore.getFuncoesProfissionalExecutante()
    if (!conveniosRepasse.length) await this.getFinanceiroStore.getConveniosRepasse()
    if (!viasAcesso.length) await this.getFinanceiroStore.getViasAcesso()
    if (!motivosInclusaoItemAvulso.length) await this.getFinanceiroStore.getMotivoInclusao()

    this.getFinanceiroStore.setModal({ name: 'novoItemAvulsoRepasse', value: true, context: 'cargaDeItens' })
    this.loadShowModalItemAvulso = ''
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSituacaoStore.getHistoricoGeracaoRepasse(solicitacaoId)
    this.loadingHistorico = ''
  }

  async showModalCargaItens(id: string) {
    this.loadingShowModalItemAvulso = id
    this.getFinanceiroStore.setIdForLoadItemAvulso(id)

    // Verifica se existem itens salvos da última requisição
    const { codigoProcedimento, centroDeCusto, transacaoFinanceira, profissionaisExecutantes, motivosInclusaoItemAvulso, funcoesProfissionalExecutante, conveniosRepasse, viasAcesso } = this.getFinanceiroStore

    if (!codigoProcedimento.length) await this.getFinanceiroStore.getProcedimentos()
    if (!transacaoFinanceira.length) await this.getFinanceiroStore.getTransacaoFinanceira()
    if (!centroDeCusto.length) await this.getFinanceiroStore.getCentroDeCusto()
    if (!profissionaisExecutantes.length) await this.getFinanceiroStore.getProfissionais()
    if (!funcoesProfissionalExecutante.length) await this.getFinanceiroStore.getFuncoesProfissionalExecutante()
    if (!conveniosRepasse.length) await this.getFinanceiroStore.getConveniosRepasse()
    if (!viasAcesso.length) await this.getFinanceiroStore.getViasAcesso()
    if (!motivosInclusaoItemAvulso.length) await this.getFinanceiroStore.getMotivoInclusao()

    this.getFinanceiroStore.setModal({ name: 'novoItemAvulsoRepasse', value: true, context: 'cargaGeracao' })
    this.loadShowModalItemAvulso = ''
  }

  async showModalItensDoRepasse(item: any) {
    this.loadingShowModalItensDoRepasse = item.id
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setIdForLoadPrestadores(item.fontePagadoraId)
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(item.id)
    await this.getFinanceiroStore.getPontuacaoProfissional()
    await this.getFinanceiroStore.getProfissionais()
    await this.getFinanceiroStore.getFuncoesProfissionalExecutante()
    await this.getFinanceiroStore.getTipoItens()
    this.getFinanceiroStore.setModal({ name: 'itensDoRepasse', value: true })
    this.loadingShowModalItensDoRepasse = ''
  }

  async showModalDesfazerLiberacao(item: any) {
    this.loadingShowModalDesfazerLiberacao = item.id
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setPrestadorId(item.prestadorId)
    this.getFinanceiroStore.setModal({ name: 'desfazerLiberacao', value: true })
    this.loadingShowModalDesfazerLiberacao = ''
  }

  async openModalDesfazerIntegracao(item: any) {
    this.loadingShowModalDesfazerIntegracao = item.id
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setModal({ name: 'desfazerIntegracao', value: true })
    this.loadingShowModalDesfazerIntegracao = ''
  }

  async showModalIntegrarRepasse(item: any) {
    this.loadingShowModalIntegrarRepasseUnico = item.id
    await timeoutDefault()
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setModal({ name: 'integrarRepasseUnico', value: true })
    this.loadingShowModalIntegrarRepasseUnico = ''
  }

  async showModalLiberarRepasseUnico(item: any) {
    this.loadingShowModalLiberarRepasseUnico = item.id
    await timeoutDefault()
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setPrestadorRecebimentoId(item.prestadorId)
    this.getFinanceiroStore.setModal({ name: 'liberarRepasseUnico', value: true })
    this.loadingShowModalLiberarRepasseUnico = ''
  }

  async showModalDescontosPrestador(item: any) {
    this.loadingShowModalDescontosPrestador = item.id
    await timeoutDefault()
    await this.getFinanceiroStore.getAllDescontosPrestador(item.prestadorId)
    this.getFinanceiroStore.setModal({ name: 'descontosPrestador', value: true })
    this.loadingShowModalDescontosPrestador = ''
  }

  async openModalEmitirRelatorio() {
    this.loadingShowModalEmitirRelatorio = true
    this.getFinanceiroStore.setModal({ name: 'emitirRelatorio', value: true })
    this.loadingShowModalEmitirRelatorio = false
  }

  async getResults(pagina: number) {
    const id = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async downloadArquivos(item: any) {
    this.loadingDownloadArquivos = item.id
    const response = await this.getFinanceiroStore.downloadCargasGeracao(item.id)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao baixar arquivo.', icon: 'warning', color: '#C62828' })
      this.loadingDownloadArquivos = ''
      return
    }

    fetch(response.data)
      .then((request: Response) => request.arrayBuffer())
      .then((buffer: ArrayBuffer) => new File([buffer], 'carga_recebimento.xlsx', { type: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      .then((file: File) => FileSaver.saveAs(file))

    this.loadingDownloadArquivos = ''
  }

  // Advanced-filters
  get drawer() {
    return this.getFinanceiroStore.filterValidacaoEGeracaoRepasseDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterValidacaoEGeracaoRepasseDrawer(value)
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async clearAdvancedFilters() {
    this.getFinanceiroStore.clearFilterValidacaoEGeracaoRepasse()
    this.getFinanceiroStore.setFilterOn(false)
    const id = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
  }

  @Watch('modalValidacaoEGeracaoRepasse')
  onChangeModalValidacaoEGeracaoRepasse(value: boolean) {
    if (!value) {
      this.clearAdvancedFilters()
      this.getFinanceiroStore.clearProcedimentos()
      this.getFinanceiroStore.clearTransacaoFinanceira()
      this.getFinanceiroStore.clearCentroDeCusto()
      this.getFinanceiroStore.clearProfissionaisExecutantes()
      this.getFinanceiroStore.clearMotivosInclusao()
      this.getFinanceiroStore.clearPagePagination()
      this.getFinanceiroStore.clearItensDeRepasseSelecionados()
    }
  }

  @Watch('desfazerIntegracao')
  onChangeResponseSuccessDesfazerIntegracao(value: boolean) {
    if (!value) {
      this.getResults(1)
    }
  }

  get selected() { return this.getFinanceiroStore.itensDeRepasseSelecionados }
  set selected(value: any) { this.getFinanceiroStore.setItensDeRepasseSelecionados(value) }

  get algumItemAptoAIntegrar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.some((item: any) => Boolean(item.acoes.PodeIntegrar)) }
  get algumItemAptoALiberar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.some((item: any) => Boolean(item.acoes.PodeLiberar)) }

  openModalIntegrarItensDeGeracaoDeRepasseNoHis() {
    this.getFinanceiroStore.setModal({ name: 'integrarRepasseMultiplo', value: true })
  }

  openModalLiberarItensDeGeracaoDeRepasseNoHis() {
    this.getFinanceiroStore.setModal({ name: 'liberarRepasseMultiplo', value: true })
  }
}
